import { Button } from "@garther/ui/components";
import { Link } from "@tanstack/react-router";

export function NotFoundPage() {
  return (
    <div className="relative min-h-screen e-center px-4 bg-background-primary">
      {/* Content */}
      <div className="relative z-10 max-w-md w-full text-center bg-background-secondary rounded-sm p-8 border border-border-dark">
        {/* 404 Icon */}
        <div className="mb-8">
          <div className="mx-auto w-16 h-16 bg-background-dark-secondary rounded-full e-center shadow-lg">
            <span className="text-responsive-2xl font-bold text-text-inverse">404</span>
          </div>
        </div>
        {/* Error Message */}
        <h1 className="text-responsive-2xl font-normal text-text-primary mb-4">Oops! Page Not Found</h1>
        <p className="text-responsive-base text-text-secondary mb-8">
          The page you're looking for seems to have wandered off. Don't worry, we'll help you find your way
          back!
        </p>

        {/* Navigation Options */}
        <div className="space-y-4">
          <Button variant="default" className="w-full">
            <Link to="/home" className="w-full">
              Homepage
            </Link>
          </Button>

          <Button variant="outline" className="w-full" onClick={() => window.history.back()}>
            Back
          </Button>
        </div>

        {/* Fun Message */}
        <div className="mt-6 p-4 bg-background-highlight rounded-sm">
          <p className="text-sm text-text-secondary">
            Tip: Make sure the URL is correct, or try refreshing the page!
          </p>
        </div>
      </div>
    </div>
  );
}
